// ./src/hooks/useWriteTimeoutNotice.ts
//
// ROADMAP #131 — when a save that got no answer makes the lists re-read, the host is TOLD, once: the save may still have
// gone through, the lists now show what the server has, so check before trying again. ⚠ The timed-out save's own message
// is not enough: a list read clears its hook's last error (so on a page with no drawer open it vanished within a tick),
// and a bulk action confirmed in a modal never showed one. Mounted once, at the app's root (App.tsx).
import { useEffect } from "react";
import { onWriteTimeoutReread } from "@em/api";

import { useToast } from "./useToast";

/** What the host reads when the lists re-read after a save that got no answer. Stays until dismissed. */
export const WRITE_TIMEOUT_REREAD_NOTICE =
  "A save got no answer from the server — it may still have gone through. The list has been re-read: check it before trying again.";

export const useWriteTimeoutNotice = (): void => {
  const toast = useToast();

  useEffect(
    () =>
      onWriteTimeoutReread(() => {
        toast.warning(WRITE_TIMEOUT_REREAD_NOTICE, { autoClose: false });
      }),
    [toast]
  );
};
